import { translate } from '@/domain/utils/translate';
import i18n from '@/domain/utils/i18n';

/**
 * Librería de Rutas
 */
export const getRoutesDirections = (language?: string) => {
  return {
    MAIN_ROUTE: '/',
    ERROR_ROUTE: '/error',
    NOT_FOUND_ROUTE: '*',

    /** Declaración de Rutas Relacionadas al usuario */
    USER_INFO_ROUTE: translate('breadcrumbs.urls.user_account', language ?? i18n.language),

    CHANGE_PASSWORD_ROUTE: translate('breadcrumbs.urls.change_password', language ?? i18n.language),

    PASSWORD_CODE_ROUTE: translate('breadcrumbs.urls.password_code', language ?? i18n.language),

    PASSWORD_RESET_ROUTE: translate('breadcrumbs.urls.password_reset', language ?? i18n.language),

    /** Declaración de Rutas Relacionadas a la tienda */
    STORE_ROUTE: translate('breadcrumbs.urls.store', language ?? i18n.language),
    STORE_BY_PAGE: translate('breadcrumbs.urls.store_by_page', language ?? i18n.language),
    STORE_BY_CATEGORY_ROUTE: translate('breadcrumbs.urls.store_by_category', language ?? i18n.language),
    PRODUCT_ROUTE: translate('breadcrumbs.urls.product', language ?? i18n.language),
    PRODUCT_DETAILS_ROUTE: translate('breadcrumbs.urls.product_details', language ?? i18n.language),
    CART_ROUTE: translate('breadcrumbs.urls.cart', language ?? i18n.language),
    CHECK_OUT_ROUTE: translate('breadcrumbs.urls.chekout', language ?? i18n.language),
    PURCHASES_ROUTE: translate('breadcrumbs.urls.purchases', language ?? i18n.language),

    /** Declaración de Rutas Relacionadas al CRUD */
    INVENTORY_ROUTE: translate('breadcrumbs.urls.inventory', language ?? i18n.language),
    MASSIVE_CHARGE_ROUTE: translate('breadcrumbs.urls.massive_charge', language ?? i18n.language),
    INSERT_VALIDATION_INTERFACE_ROUTE: translate('breadcrumbs.urls.insert_validation', language ?? i18n.language),
    ADD_PRODUCTS_FORM_WIZARD_ROUTE: translate('breadcrumbs.urls.add_products', language ?? i18n.language),

    /** Declaración de Rutas Relacionadas al Proceso de ventas */
    TRANSBANK_RESPONSE_ROUTE: '/checkout/transbank-response', // Esta ruta no puede cambiar, es donde responde webpay
    SALES_HISTORY_ROUTE: translate('breadcrumbs.urls.sales_history', language ?? i18n.language),

    /**Ruta de seguimiento */
    TRACKING_ROUTE: translate('breadcrumbs.urls.traking', language ?? i18n.language),
    TRACKING_ROUTE_DETAIL: translate('breadcrumbs.urls.traking_detail', language ?? i18n.language),

    /** Declaración de Rutas Temporales */
    LIBRARY_ROUTE: translate('breadcrumbs.urls.library', language ?? i18n.language),

    CONSTRUCTION_ROUTE: translate('breadcrumbs.urls.building', language ?? i18n.language),

    BLOG_ROUTE: translate('breadcrumbs.urls.blog', language ?? i18n.language),
  };
};
